import { FC, useCallback } from 'react';
import { Button, Input } from 'antd';
import useLogin from '../Hooks/LoginHooks';
import { useHistory } from 'react-router-dom';
import { getAppRoutes } from 'Pages/App/App.constants';
import styles from './TenantLogin.module.scss';

const TenantLogin: FC = () => {
	const formik = useLogin();
	const history = useHistory();

	const forgotPassword = useCallback(() => {
		history.push(getAppRoutes().RESET_PASSWORD);
	}, [history]);

	return (
		<div className={styles.container}>
			<div className={styles.title}>Sign in</div>

			<form onSubmit={formik.handleSubmit}>
				<div className={styles.field}>
					<label>Username</label>
					<Input
						name="username"
						size="large"
						value={formik.values.username}
						onChange={formik.handleChange}
						onBlur={formik.handleBlur}
					/>
					{formik.touched.username && formik.errors.username && (
						<div className={styles.errorMsg}>
							{formik.errors.username}
						</div>
					)}
				</div>

				<div className={styles.field}>
					<label>Password</label>
					<Input
						name="password"
						type="password"
						size="large"
						value={formik.values.password}
						onChange={formik.handleChange}
						onBlur={formik.handleBlur}
					/>
					{formik.touched.password && formik.errors.password && (
						<div className={styles.errorMsg}>
							{formik.errors.password}
						</div>
					)}
				</div>

				<Button
					type="primary"
					shape="round"
					className="cta-prominent"
					htmlType="submit"
					loading={formik.isSubmitting}
				>
					Log in
				</Button>
			</form>

			{formik.status && (
				<div className={styles.errorMsg}>{formik.status}</div>
			)}

			<div className={styles.forgotPassword} onClick={forgotPassword}>
				Forgot your password?
			</div>
		</div>
	);
};

export default TenantLogin;